module.exports = __webpack_public_path__ + "static/media/rangaj mandir_page-0001.acae82de.jpg";